import React from "react";
import portfolio from "../../../assets/portfolio.jpg";
import "./Home.scss";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Home = () => {
  const moveVariants = {
    animation: {
      y: [0, -15],
      transition: {
        yoyo: Infinity,
        duration: 2,
        delay: 1,
      },
    },
  };

  return (
    <motion.div
      className="container "
      id="home"
      initial={{ y: -15, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 2,
        delay: 0.5,
      }}
    >
      <div className="profile">
        <img src={portfolio} alt="portfolio" />
      </div>
      <div className="profile_text">
        <h3 className="name">
          Hi, I'm <span>Utkarsh</span>{" "}
        </h3>
        <span className="job">Full stack Developer based in India</span>
        <span className="text">
          Passionate
          <br /> to craft innovative <br /> web products.
        </span>
        <motion.a
          whileHover={{ scale: 1.1 }}
          variants={moveVariants}
          animate="animation"
        >
          <Link to="/contact">connect with me</Link>
        </motion.a>
        <div className="web">Web Developer</div>
        <div className="ui">Instructor</div>
        <div className="freelance">Software Engineer</div>
      </div>
    </motion.div>
  );
};

export default Home;
